module.exports = __webpack_public_path__ + "img/ic_point_5.175df299.svg";